<template>
  <section class="py-10 px-10 lg:px-32">
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
      
      <!-- Left Side: About Us Text Content -->
      <div class="space-y-6 text-center lg:text-left">
        <h1 class="text-4xl lg:text-7xl font-bold text-[#E3A13F] uppercase drop-shadow-[2px_2px_5px_rgba(227,161,63,0.7)]">
          About Us
        </h1>

        <hr class="border-[#E3A13F] w-32 mx-auto lg:mx-0">
        <p class="text-lg leading-relaxed font-quicksand">
          From humble beginnings, Revest360 came to be from learning about responsibility, 
          self-reliance, saving, budgeting, and protecting your assets. Further understanding financial 
          concepts such as investing and the power of compound interest. This was the lifestyle that 
          eventually led CEO <strong>Michael H. Collins</strong> to end up at Georgia Tech, and then to a job in 
          corporate America that has allowed him to now come full circle to Revest360 and the <strong>Circle of Prosperity</strong>.
        </p>
      </div>

      <!-- Right Side: About Us Image -->
      <div class="relative flex justify-center">
        <!-- Preload image for faster load time -->
        <link rel="preload" href="../assets/images/about.webp" as="image">
        <!-- Define explicit image dimensions to prevent layout shift -->
        <img src="../assets/images/about.webp" alt="Revest360 team working on financial literacy" 
             class="w-full max-w-md lg:max-w-full" width="600" height="400" style="object-fit: cover;">
      </div>
    </div>
  </section>

  <!-- Mission Vision -->
  <div class="flex flex-col md:flex-row justify-center items-center gap-16 p-6">
    
    <!-- Mission Card -->
    <div class="w-4/5 md:w-2/5 p-10 rounded-[86px] bg-[#111111] 
          border border-[#0b090a]
          shadow-[7px_7px_14px_#0a0a0a,-7px_-7px_14px_#131313] 
          transition-all duration-300 ease-in-out hover:scale-105 hover:brightness-110 
          hover:shadow-[7px_7px_14px_#e47d39,-7px_-7px_14px_#ff9f45] 
          flex flex-col items-center text-center group">
      
      <!-- Mission Icon -->
      <svg class="w-20 h-20 text-gray-500 transition-all duration-300 ease-in-out 
              group-hover:text-[#e4ac3b] group-hover:drop-shadow-[0_0_10px_#e4ac3b]" 
       xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" role="img">
        <title>Mission - Revest360 Financial Literacy</title>
        <circle cx="12" cy="12" r="9" stroke-width="2"/>
        <circle cx="12" cy="12" r="5" stroke-width="2"/>
        <circle cx="12" cy="12" r="2" stroke-width="2" fill="currentColor"/>
      </svg>
      
      <h3 class="mt-4 mb-4 text-3xl font-semibold tracking-wide text-[#e4ac3b] uppercase transition-all duration-300 
                 group-hover:drop-shadow-[0_0_10px_#e4ac3b]">Mission</h3>
      
      <p class="text-lg font-normal text-gray-400 transition-all duration-300 group-hover:text-white">
        We provide an eLibrary to meet the evolving needs of the different religions. Providing different scriptures that are accessible wherever you go.
      </p>
    </div>

    <!-- Vision Card -->
    <div class="w-4/5 md:w-2/5 p-10 rounded-[86px] bg-[#111111] 
          border border-[#0b090a]
          shadow-[7px_7px_14px_#0a0a0a,-7px_-7px_14px_#131313] 
          transition-all duration-300 ease-in-out hover:scale-105 hover:brightness-110 
          hover:shadow-[7px_7px_14px_#e47d39,-7px_-7px_14px_#ff9f45] 
          flex flex-col items-center text-center group">
      
      <!-- Vision Icon -->
      <svg class="w-20 h-20 text-gray-500 transition-all duration-300 ease-in-out 
              group-hover:text-[#e4ac3b] group-hover:drop-shadow-[0_0_10px_#e4ac3b]" 
       xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" role="img">
        <title>Vision - Digital Religious Library</title>
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.5c-4.33 0-8.25 2.91-9.83 7.05a1.003 1.003 0 000 .9C3.75 16.59 7.67 19.5 12 19.5s8.25-2.91 9.83-7.05a1.003 1.003 0 000-.9C20.25 7.41 16.33 4.5 12 4.5zM12 15a3 3 0 110-6 3 3 0 010 6z"/>
      </svg>
      
      <h3 class="mt-4 mb-4 text-3xl font-semibold tracking-wide text-[#e4ac3b] uppercase transition-all duration-300 
                 group-hover:drop-shadow-[0_0_10px_#e4ac3b]">Vision</h3>
      
      <p class="text-lg font-normal text-gray-400 transition-all duration-300 group-hover:text-white">
        To be the world’s leading digital library for religious scriptures, fostering universal access and understanding across diverse faith communities
      </p>
    </div>

  </div>
</template>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@400;600&display=swap');

.font-quicksand {
  font-family: 'Quicksand', sans-serif;
}

/* Preload the font to avoid layout shifts */
@font-face {
  font-family: 'Quicksand';
  src: url('https://fonts.gstatic.com/s/quicksand/v31/6xKtdSZaM..woff2') format('woff2');
  font-display: swap; /* Ensures font loads faster */
}
</style>
